import type { ArInvoiceDetail, GetSalesOrderResponse } from '@erp/rpc';
import { useArInvoice } from '@/api/rpc/hooks/accounts-receivable/useArInvoices';
import { useSalesOrder } from '@/api/rpc/hooks/accounts-receivable/useSalesOrders';
import type { ArTaskRecord } from './arTasksPageState';

export interface ArTaskRecords {
  invoice: ArInvoiceDetail | null;
  salesOrder: GetSalesOrderResponse['salesOrder'];
  salesOrderLines: GetSalesOrderResponse['lineItems'];
}

/**
 * The invoice and sales order behind a task: the invoice for an unsent
 * invoice (and its order), or the order for a shipped-not-invoiced task.
 * They label the task, fill its record panel, and feed its notes and activity.
 */
export function useArTaskRecords(record: ArTaskRecord | null): ArTaskRecords {
  const { invoice } = useArInvoice(
    record?.kind === 'to_send' ? record.anchorId : undefined,
  );
  const salesOrderId =
    record?.kind === 'to_invoice' ? record.anchorId : invoice?.salesOrderId;
  const salesOrderQuery = useSalesOrder(salesOrderId ?? undefined);
  return {
    invoice,
    salesOrder: salesOrderQuery.salesOrder,
    salesOrderLines: salesOrderQuery.lineItems,
  };
}
